import { makeTranslation } from "brew-js-react";
import RESOURCE_COMMON_EN from "./common.en.json";
import RESOURCE_COMMON_ZHHK from "./common.zh-HK.json";
import RESOURCE_RESET_PASSEWORD_EN from "./resetPassword.en.json";
import RESOURCE_RESET_PASSEWORD_ZHHK from "./resetPassword.zh-HK.json";
import RESOURCE_LOGIN_EN from "./login.en.json";
import RESOURCE_LOGIN_ZHHK from "./login.zh-HK.json";
import RESOURCE_HOME_EN from "./home.en.json";
import RESOURCE_HOME_ZHHK from "./home.zh-HK.json";
import RESOURCE_MY_PERF_EN from "./myPerf.en.json";
import RESOURCE_MY_PERF_ZHHK from "./myPerf.zh-HK.json";
import RESOURCE_CAMPAIGN_DETAIL_EN from "./campaignDetail.en.json"
import RESOURCE_CAMPAIGN_DETAIL_ZHHK from "./campaignDetail.zh-HK.json"
import RESOURCE_CAMPAIGN_LISTING_EN from "./campaignListing.en.json";
import RESOURCE_CAMPAIGN_LISTING_ZHHK from "./campaignListing.zh-HK.json";
import RESOURCE_BULLETIN_EN from "./bulletin.en.json";
import RESOURCE_BULLETIN_ZHHK from "./bulletin.zh-HK.json";
import RESOURCE_PRODUCT_EN from "./product.en.json";
import RESOURCE_PRODUCT_ZHHK from "./product.zh-HK.json";
import RESOURCE_FORMANDLINK_EN from "./formAndLink.en.json";
import RESOURCE_FORMANDLINK_ZHHK from "./formAndLink.zh-HK.json";
import RESOURCE_SETTING_EN from "./setting.en.json";
import RESOURCE_SETTING_ZHHK from "./setting.zh-HK.json";
import RESOURCE_NOTIFICATION_EN from "./notification.en.json";
import RESOURCE_NOTIFICATION_ZHHK from "./notification.zh-HK.json";
import RESOURCE_WHATSNEW_EN from "./whatsNew.en.json";
import RESOURCE_WHATSNEW_ZHHK from "./whatsNew.zh-HK.json";
import RESOURCE_CHANGE_PASSWORD_EN from "./changePassword.en.json";
import RESOURCE_CHANGE_PASSWORD_ZHHK from "./changePassword.zh-HK.json";
import RESOURCE_BLOCKINGS_EN from "./blockings.en.json";
import RESOURCE_BLOCKINGS_ZHHK from "./blockings.zh-HK.json";
import RESOURCE_ESERVICE_EN from "./eService.en.json";
import RESOURCE_ESERVICE_ZHHK from "./eService.zh-HK.json";
import RESOURCE_FOREVERLOVE_EN from "./eService.foreverLove.en.json";
import RESOURCE_FOREVERLOVE_ZHHK from "./eService.foreverLove.zh-HK.json";
import RESOURCE_PREMIUM_HOLIDAY_POLICY_LIST_EN from "./eService.premiumHoliday.en.json";
import RESOURCE_PREMIUM_HOLIDAY_POLICY_LIST_ZHHK from "./eService.premiumHoliday.zh-HK.json";
import RESOURCE_MYCUSTOMER_EN from "./eService.myCustomer.en.json";
import RESOURCE_MYCUSTOMER_ZHHK from "./eService.myCustomer.zh-HK.json";
import RESOURCE_PREMIUM_PAYING_RATIO_EN from "./eService.premiumPayingRatio.en.json";
import RESOURCE_PREMIUM_PAYING_RATIO_ZHHK from "./eService.premiumPayingRatio.zh-HK.json";
import RESOURCE_REMINDERS_EN from "./reminders.en.json";
import RESOURCE_REMINDERS_ZHHK from "./reminders.zh-HK.json";
import RESOURCE_DEPARTMENTS_EN from "./departments.en.json";
import RESOURCE_DEPARTMENTS_ZHHK from "./departments.zh-HK.json";
import RESOURCE_IMPORTANT_NOTICE_EN from "./importantNotice.en.json"
import RESOURCE_IMPORTANT_NOTICE_ZHHK from "./importantNotice.zh-HK.json"
import RESOURCE_LOUSUPPLEMENTALAGREEMENT_EN from "./louSupplementalAgreement.en.json";
import RESOURCE_LOUSUPPLEMENTALAGREEMENT_ZHHK from "./louSupplementalAgreement.zh-HK.json";

const resources = {
    en: {
        common: RESOURCE_COMMON_EN,
        resetPassword: RESOURCE_RESET_PASSEWORD_EN,
        login: RESOURCE_LOGIN_EN,
        home: RESOURCE_HOME_EN,
        myPerf: RESOURCE_MY_PERF_EN,
        product: RESOURCE_PRODUCT_EN,
        formAndLink: RESOURCE_FORMANDLINK_EN,
        setting: RESOURCE_SETTING_EN,
        notification: RESOURCE_NOTIFICATION_EN,
        whatsNew: RESOURCE_WHATSNEW_EN,
        campaignListing: RESOURCE_CAMPAIGN_LISTING_EN,
        campaignDetail: RESOURCE_CAMPAIGN_DETAIL_EN,
        bulletin: RESOURCE_BULLETIN_EN,
        changePassword: RESOURCE_CHANGE_PASSWORD_EN,
        blockings: RESOURCE_BLOCKINGS_EN,
        eService: RESOURCE_ESERVICE_EN,
        foreverLove: RESOURCE_FOREVERLOVE_EN,
        premiumHolidayPolicyList: RESOURCE_PREMIUM_HOLIDAY_POLICY_LIST_EN,
        myCustomer: RESOURCE_MYCUSTOMER_EN,
        premiumPayingRatio: RESOURCE_PREMIUM_PAYING_RATIO_EN,
        reminders: RESOURCE_REMINDERS_EN,
        departments: RESOURCE_DEPARTMENTS_EN,
        importantNotice: RESOURCE_IMPORTANT_NOTICE_EN,
        louSupplementalAgreement: RESOURCE_LOUSUPPLEMENTALAGREEMENT_EN,
    },
    'zh-hk': {
        common: RESOURCE_COMMON_ZHHK,
        resetPassword: RESOURCE_RESET_PASSEWORD_ZHHK,
        login: RESOURCE_LOGIN_ZHHK,
        home: RESOURCE_HOME_ZHHK,
        myPerf: RESOURCE_MY_PERF_ZHHK,
        product: RESOURCE_PRODUCT_ZHHK,
        formAndLink: RESOURCE_FORMANDLINK_ZHHK,
        setting: RESOURCE_SETTING_ZHHK,
        notification: RESOURCE_NOTIFICATION_ZHHK,
        whatsNew: RESOURCE_WHATSNEW_ZHHK,
        campaignListing: RESOURCE_CAMPAIGN_LISTING_ZHHK,
        campaignDetail: RESOURCE_CAMPAIGN_DETAIL_ZHHK,
        bulletin: RESOURCE_BULLETIN_ZHHK,
        changePassword: RESOURCE_CHANGE_PASSWORD_ZHHK,
        blockings: RESOURCE_BLOCKINGS_ZHHK,
        eService: RESOURCE_ESERVICE_ZHHK,
        foreverLove: RESOURCE_FOREVERLOVE_ZHHK,
        premiumHolidayPolicyList: RESOURCE_PREMIUM_HOLIDAY_POLICY_LIST_ZHHK,
        myCustomer: RESOURCE_MYCUSTOMER_ZHHK,
        premiumPayingRatio: RESOURCE_PREMIUM_PAYING_RATIO_ZHHK,
        reminders: RESOURCE_REMINDERS_ZHHK,
        departments: RESOURCE_DEPARTMENTS_ZHHK,
        importantNotice: RESOURCE_IMPORTANT_NOTICE_ZHHK,
        louSupplementalAgreement: RESOURCE_LOUSUPPLEMENTALAGREEMENT_ZHHK,
    },
};

export const { translate, useTranslation } = makeTranslation(resources, 'en');
